import { createService } from '@/helpers/hasura'

import gql from 'graphql-tag'

import { ShopFragment } from '@/helpers/api/fragments'

const output = `
    ...Shop
`

const fragments = gql`
  ${ShopFragment}
`

const allowedFields = ['name', 'is_active']

export default config => {
  const service = createService({
    ...config,
    table: 'shop',
    defaultPageSize: 25,
    defaultOrderBy: [{ name: 'asc' }],
    defaultSearchBy: ['name'],
    defaultFilters: [],
    defaultOutput: output,
    defaultFragments: fragments,
    allowedFields
  })

  return {
    ...service
  }
}
